var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCovers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    fillRule: "evenodd",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "0.5em",
    height: "0.5em",
    viewBox: "0 0 36 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document",
    fill: "none",
    stroke: "black",
    fontFamily: "Times New Roman",
    fontSize: 16,
    transform: "scale(1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Spread",
    transform: "translate(0 -66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#666666",
    fillRule: "evenodd",
    strokeLinejoin: "miter",
    stroke: "none",
    strokeWidth: 0.126,
    strokeMiterlimit: 79.8403193612775
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.835,42.277 L 5.835,4.391 C 5.835,3.403 6.191,2.55 6.904,1.824 C 7.602,1.116 8.441,0.766 9.402,0.752 C 10.354,0.766 11.18,1.116 11.885,1.824 C 12.609,2.55 12.965,3.403 12.965,4.391 L 12.965,42.277 C 14.035,42.662 18.046,46.285 18.046,47.439 L 18.046,62.675 C 18.046,63.175 17.874,63.593 17.518,63.957 C 17.155,64.324 16.73,64.498 16.245,64.498 C 15.757,64.498 15.331,64.324 14.975,63.957 C 14.619,63.593 14.442,63.175 14.442,62.675 L 14.442,50.821 C 14.442,50.341 14.256,49.911 13.912,49.552 C 13.539,49.192 13.125,49.013 12.635,49.013 C 12.146,49.013 11.72,49.192 11.357,49.552 C 11.01,49.911 10.824,50.341 10.824,50.821 L 10.824,62.675 C 10.824,63.175 10.659,63.593 10.298,63.957 C 9.942,64.324 9.509,64.498 9.025,64.498 C 8.542,64.498 8.111,64.324 7.755,63.957 C 7.399,63.593 7.222,63.175 7.222,62.675 L 7.222,50.821 C 7.222,50.341 7.036,49.911 6.689,49.552 C 6.331,49.192 5.898,49.013 5.422,49.013 C 4.926,49.013 4.507,49.192 4.151,49.552 C 3.79,49.911 3.611,50.341 3.611,50.821 L 3.611,62.675 C 3.611,63.175 3.434,63.593 3.076,63.957 C 2.72,64.324 2.301,64.498 1.813,64.498 C 1.322,64.498 0.896,64.324 0.54,63.957 C 0.186,63.593 0,63.175 0,62.675 L 0,47.439 C 0,46.285 4.761,42.662 5.835,42.277 Z",
    markerStart: "none",
    markerEnd: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.438,0.743 C 9.419,0.743 9.419,0.752 9.402,0.752 C 9.381,0.752 9.375,0.743 9.351,0.743 L 9.438,0.743 Z",
    markerStart: "none",
    markerEnd: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32.491,0 C 32.465,0 32.452,0.005 32.44,0.005 C 32.421,0.005 32.408,0 32.396,0 L 32.491,0 Z",
    markerStart: "none",
    markerEnd: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.782,33.179 L 28.88,33.179 L 28.88,3.641 C 28.88,2.65 29.243,1.791 29.955,1.086 C 30.653,0.367 31.486,0.012 32.44,0.005 C 33.399,0.012 34.232,0.367 34.939,1.086 C 35.642,1.791 36,2.65 36,3.641 L 36,64.17 C 36,64.667 35.828,65.095 35.477,65.467 C 35.116,65.821 34.69,66 34.208,66 L 32.898,66 C 30.42,66 28.303,65.107 26.535,63.323 C 24.762,61.537 23.878,59.386 23.878,56.882 L 23.878,34.098 C 23.878,33.841 23.975,33.636 24.145,33.45 C 24.331,33.27 24.541,33.179 24.782,33.179 Z",
    markerStart: "none",
    markerEnd: "none"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCovers);
export default __webpack_public_path__ + "static/media/icon-covers.56f7c8fb9fbc64b2010aa83eb0bfeb56.svg";
export { ForwardRef as ReactComponent };